module.exports = __webpack_public_path__ + "img/enable-split-file-tips.62928b5b.svg";